import React, { Component } from 'react';
import './App.css';
import Header from './Header'
import Footer from './Footer'
import HomeScreen from "./HomeScreen"
import Intro from "./Intro"
import Decades from "./Decades"
import YourView from "./YourView"

class App extends Component {
  
  render() {
    return (
      <div>
        {/* <Footer/> */}
        {/* <YourView/> */}
        <Header/>
        <HomeScreen/>
        <Intro/>
        <Decades/>
        <YourView/>
        <Footer/>
      </div>
    );
  }
}

export default App;
